import UsersFeedback from './UsersFeedback.page';

export default UsersFeedback;
